<template>
  <ProductPage
    :theme="theme"
    :page-meta="pageMeta"
    :sections="sections"
    :features="features"
    :architecture="architecture"
    :why-us="whyUs"
    :scenarios="scenarios"
    :related-products="relatedProducts"
    contact-path="/smart-party"
    default-product="智慧党建系统"
  />
</template>

<script>
import ProductPage from '../components/ProductPage.vue'
import {
  theme,
  pageMeta,
  sections,
  features,
  architecture,
  whyUs,
  scenarios,
  relatedProducts
} from '../data/smart-party'

export default {
  name: 'SmartParty',
  components: { ProductPage },
  data() {
    return {
      theme,
      pageMeta,
      sections,
      features,
      architecture,
      whyUs,
      scenarios,
      relatedProducts
    }
  }
}
</script>
